import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {SmartDoor} from '@model/product/smart-door/smart-door.model';
import {animate, animateChild, query, stagger, style, transition, trigger} from '@angular/animations';
import {CustomerCareService} from '@api/customer-care.service';
import {SmartDoorActivity} from '@model/product/smart-door/activity/smart-door-activity.model';

@Component({
  selector: 'app-smartdoor',
  templateUrl: './smartdoor.component.html',
  styleUrls: ['./smartdoor.component.scss'],
  animations: [
    trigger('slide', [
      transition('void => *', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('0.1s ease-in'),
      ]),
    ]),
    trigger('fade', [
      transition('void => *', [style({ opacity: 0 }), animate(200)]),
    ]),
    trigger('stagger', [
      transition('void => *', [
        query('div', stagger('-.005s ease-in', [animateChild()])),
      ]),
    ]),
  ],
})
export class SmartdoorComponent implements OnInit, OnChanges {

  @Input()
  smartdoor: SmartDoor = null;

  @Input()
  friendlyName: string;
  /**
   * StartDate for Activity Feed Request Filter
   */
  startDate: Date = new Date();

  /**
   * EndDate for Activity Feed Request Filter
   */
  endDate: Date = new Date();

  activities: Array<SmartDoorActivity>;

  constructor(private customerCareService: CustomerCareService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.smartdoor) {
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 60);
      this.endDate = new Date();
      this.customerCareService.getSmartDoorActivity({
          thingName: this.smartdoor.thingName,
          effectiveGroupId: this.smartdoor.shadow.state.reported.groupId,
          startDate: this.startDate.valueOf(),
          endDate: this.endDate.valueOf()
        }).subscribe(
        (value) => {
          this.activities = value.data;
        }
      );
      // this.customerCareService.getProductPreferences({
      //   thingName: this.smartdoor.thingName,
      //   productType: this.smartdoor.productType
      // }).subscribe(
      //   (value) => {
      //     console.log(value);
      //   }, (error) => {
      //     console.log(error);
      //   }
      // );
    }
  }
}
